import RequiredSign from "@components/common/ui-elements/required-sign";
import ButtonGroup from "@components/common/form-controls/button-group";
import {TERMS_AGREEMENT_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import {ValidateStep4Data} from "@validators/motor-cycle-insurance-form/step4-validator";
import {showValidationErrorsModal} from "@utils/modal-manager";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import {
    MOTOR_CYCLE_COVERAGE_TYPES,
    MOTOR_CYCLE_VOLUNTARY_EXCESS_OPTIONS
} from "@constants/dropdown-choices";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";
import {TermsAgreementBlock} from "@components/common/form-blocks/other/terms-agreement-block";

export default function IF_Step4(
    {
        data,
        handlers, setCurrentStep,
        addAdditionalDriver,
        handleAdditionalDiverPropChange,
        removeAdditionalDiverByIndex,
        handleAdditionalDriverAccidentPropChange,
        addAdditionalDriverAccident,
        removeAdditionalDriverAccident,
        onSubmit,
        formRef
    }) {

    const onPrevBtnClick = (event) => {
        setCurrentStep(3);
    }

    const onNextBtnClick = (event) => {

        let validationResult = ValidateStep4Data(data);

        if (validationResult.length) {

            showValidationErrorsModal({
                validationResult : validationResult
            });


        } else {
            onSubmit();
        }


    }

    return (
        <div className='if-step-4'>
            <SectionHeading
                text="Your cover"
            />


            <div className="row">

                {/* Level of cover required? */}

                <ScrollableDropdownBlock
                    controlName="levelOfCover"
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Level of cover required?"
                    required={true}
                    options={MOTOR_CYCLE_COVERAGE_TYPES}
                    selectedValues={data.levelOfCover}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* What voluntary excess do you want? */}

                <ScrollableDropdownBlock
                    controlName="voluntaryExcessAmount"
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="What voluntary excess do you want?"
                    required={false}
                    options={MOTOR_CYCLE_VOLUNTARY_EXCESS_OPTIONS}
                    selectedValues={data.voluntaryExcessAmount}
                    onChange={handlers.onControlChange}
                    helpText=""
                />
               
               {/* Additional comments */}
               
               <ScrollableTextBoxBlock
                  containerCssClass="col-12 py-3 "
                  labelText="Additional comments"
                  required={false}
                  controlName="addAdditionalComments"
                  value={data.addAdditionalComments}
                  onChange={handlers.onControlChange}
                  inputAttrs={{
                     maxLength: 1024,
                     rows: 5
                  }}
                  asTextArea={true}
               />
               
            </div>

            {/*<div className="row">
                 name of last Insurer

                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="name of last Insurer"
                    required={true}
                    controlName="nameOfLastInsurer"
                    value={data.nameOfLastInsurer}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

                 Renewal quote from your insurer

                <ScrollableTextBoxBlock
                    type="number"
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Renewal quote from your insurer"
                    required={true}
                    controlName="renewalQuoteFromLastInsurer"
                    value={data.renewalQuoteFromLastInsurer}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

            </div>*/}
            

           

           <TermsAgreementBlock
              controlName={"termsAgreement"}
              controlIdPrefix={"termsAgreement-"}
              required={true}
              onChange={handlers.onControlChange}
              selectedValue={data.termsAgreement}
              labelText={"Terms agreement"}
              isHidden={false}
           />
           

           
           <WizardStepButtonsBlock
              onPrevBtnClick={onPrevBtnClick}
              onNextBtnClick={onNextBtnClick}
              isNextBtnDisabled={data.termsAgreement !== 'Yes'}
              nextBtnText={"Submit"}
              nextBtnIconPosition={"left"}
              nextBtnIconClass={`fa fa-save me-2`}
           />

        </div>
    );
}